import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt", "tabIndex", "role"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('image')),
    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onElClick && _ctx.onElClick(...args)))
  }, [
    _createElementVNode("img", {
      src: _ctx.component.imageUrl,
      alt: _ctx.component.alt || 'IMAGE',
      tabIndex: _ctx.enableMessageNavigation ? 0 : -1,
      role: _ctx.enableMessageNavigation ? 'img' : null,
      class: _normalizeClass(_ctx.isFirefoxSVGClass ? _ctx.getClass('firefox-svg') : '')
    }, null, 10 /* CLASS, PROPS */, _hoisted_1)
  ], 2 /* CLASS */))
}